import { Injectable } from '@angular/core';
import { RequestOptions, Response, URLSearchParams } from '@angular/http';

import { AuthHttp } from 'app/infrastructure/common';
import { AppSettings } from 'app/infrastructure/settings';


@Injectable()
export class CustomerService {

	constructor(private http: AuthHttp) { }

	getCustomerListByAll(isIncludeAll?: boolean) {
		let params: URLSearchParams = new URLSearchParams();
        params.set('isIncludeAll', String(isIncludeAll));

        let options: RequestOptions = new RequestOptions({ search: params });
        return this.http.get(AppSettings.apiEndpoint + 'Customer/GetCustomerListByAll', options)
            .map((response: Response) => response.json());
	}

	getCustomerListByFilter(filter: string) {
		let params: URLSearchParams = new URLSearchParams();
        params.set('filter', filter);

        let options: RequestOptions = new RequestOptions({ search: params });
        return this.http.get(AppSettings.apiEndpoint + 'Customer/GetCustomerListByFilter', options)
            .map((response: Response) => response.json());
	}

	getCustomerByKey(customerCode: string) {
		let params: URLSearchParams = new URLSearchParams();
        params.set('customerCode', customerCode);

        let options: RequestOptions = new RequestOptions({ search: params });
        return this.http.get(AppSettings.apiEndpoint + 'Customer/GetCustomerByKey', options)
            .map((response: Response) => response.json());
	}

    getCustomerByZipCode(zipCode: string) {
		let params: URLSearchParams = new URLSearchParams();
        params.set('zipCode', zipCode);

        let options: RequestOptions = new RequestOptions({ search: params });
        return this.http.get(AppSettings.apiEndpoint + 'Customer/GetCustomerByZipCode', options)
            .map((response: Response) => response.json());
	}

    SaveWithOwnerAndAssignToUser(model: any) {
        return this.http.post(AppSettings.apiEndpoint + "Customer/SaveWithOwnerAndAssignToUser", model)
            .map((response: Response) => response.json());
    }
}



// WEBPACK FOOTER //
// ./src/app/infrastructure/services/master/wm/business-partner/customer.service.ts